import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useMemo, useState, useRef } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { ClockLoader, GridLoader } from "react-spinners";
import { MenuContext } from "../context/MenuContext";
import { TbPigMoney } from "react-icons/tb";
import { BiMoneyWithdraw } from "react-icons/bi";
import { TopBar } from "../components/topbar";
import { IoIosSearch } from "react-icons/io";
import { FaPlaneArrival, FaPlaneDeparture, FaPlaneSlash } from "react-icons/fa";
import { MdAirplanemodeActive } from "react-icons/md";
import { TostMessageContext } from "../context/TostMessage";
import { BellIcon, PinIcon, CloudOffIcon, FareCard, Icon, Feature, DateInput, TextInput } from "../components/icons";
import { FaPeopleGroup } from "react-icons/fa6";

export default function ConfirmBooking() {
    const {state} = useLocation();
    const [tripType, setTripType] = useState("single");
    const [cookies] = useCookies();
    const [loading, setLoading] = useState(false);
    const progress = 0.75; // 75%
    const navigate = useNavigate();
    const {setTostMessage, userProfile} = useContext(TostMessageContext);
    const [pageData, setPageData] = useState({});
    const [airports, setAirports] = useState(cookies?.userProfile?.airports)
    const [passengers, setPassengers] = useState([
        { firstName: "", lastName: "", dob: "", passport: "", fareId: state?.flight_fares[0]?.id },
    ]);

    const fares = useMemo(
    () => [
      {
        id: "regular",
        title: "Regular Experience",
        subtitle: "Standard luxury travel",
        price: "$18,500",
        tag: null,
        features: ["Standard Catering", "High-speed Global WiFi", "Extra Luggage (2 Pieces)"],
      },
      {
        id: "vip",
        title: "VIP Sovereign",
        subtitle: "Unmatched bespoke service",
        price: "$24,900",
        tag: "PREMIUM",
        features: [
          "Gourmet Chef-prepared Meal",
          "Unlimited Starlink Global WiFi",
          "Priority Luggage & Concierge",
          "Private Chauffeur to Aircraft",
        ],
      },
    ],
    []
  );

//   const [selectedFareId, setSelectedFareId] = useState(state?.flight_fares[0]?.id);

  const total = useMemo(() => {
    const sum = passengers.reduce((acc, p) => {
    const fare = state?.flight_fares?.find(f => f.id === p.fareId);
    const amount = Number((fare?.price || "").replace(/[^0-9.]/g, ""));
    return acc + (amount || 0);
    }, 0);

    return sum;
  }, [fares, passengers, passengers.length]);

  const formattedTotal = useMemo(() => {
    return `$${total.toLocaleString("en-US")}`;
  }, [total]);

  const updatePassenger = (idx, patch) => {
    setPassengers((prev) => prev.map((p, i) => (i === idx ? { ...p, ...patch } : p)));
  };

  const addPassenger = () => {
    if (passengers?.length >= state?.flight?.seat_capacity) {
        setTostMessage({
            messageType: 'error',
            message: `There are only ${state?.flight?.seat_capacity} seat(s) left on this flight`
        })
        return;
    }
    setPassengers((prev) => [...prev, { firstName: "", lastName: "", dob: "", passport: "", fareId: state?.flight_fares[0]?.id }]);
  };

  const removePassenger = (idx) => {
    setPassengers((prev) => prev.filter((_, i) => i !== idx));
  };

    const getData = async () => {
        setLoading(true);
        const postData = new FormData();
        // postData.append('fromAirport', fromAirport.airport_id);
        // postData.append('toAirport', toAirport.airport_id);
        // postData.append('date', date);

        try {
            const response = await axios.post(base_url + '/flight-search/get_data.php', postData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                },
            });
            if (response.data.status) {
                setLoading(false);
                setPageData({...pageData, quick_deals: response.data.data, flexible_flights: response.data.flexible_flights })
            } else {
                setTostMessage({
                    messageType: 'error',
                    message: response.data.message
                })
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            setTostMessage({
                messageType: 'error',
                message: 'Network Error'
            })
        }
    }

    const proceedToPay = () => {
        if (passengers[0].firstName == "" || passengers[0].lastName == "") {
            setTostMessage({
                messageType: 'error',
                message: 'Add atleast one passenger'
            })
            return;
        }

        navigate('pay', {
            state: {
                passengers,
                flight_fares: state?.flight_fares,
                flight_id: state?.flight_id,
                fromAirport: state?.fromAirport,
                toAirport: state.toAirport,
                date: state?.date,
                flight_no: state?.flight_no,
                flight: state?.flight,
                total: total
            }
        });
    }

    return(
        <div className="w-full h-full">
            <TopBar />
            {loading && (
                <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] fixed">
                    <ClockLoader
                        color={'#d8b05a'}
                        loading={true}
                        size={40}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                </div>
            )}
            <div className="w-full p-4 sm:p-6">
                <div className="mb-2">
                    <p className="max-w-xl text-sm sm:text-base text-white/40">
                        Flight {state?.flight_no} from {state?.fromAirport.city} to {state?.toAirport.city} on {state?.date}
                    </p>
                </div>
                <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
                    <div>
                        <div className="flex items-center gap-3">
                            <div className="text-[#d8b05a]">
                                <FaPeopleGroup size={20} />
                            </div>
                            <div className="text-xl font-semibold text-white/90">
                                Passenger Details
                            </div>
                        </div>
                        <p className="mt-1 text-sm text-white/50">
                            Please ensure details match government-issued identification.
                        </p>
                    </div>

                    {/* <button
                        type="button"
                        onClick={addPassenger}
                        className={[
                        "inline-flex items-center justify-center gap-2 rounded-xl",
                        "border border-[#d8b05a]/30 bg-white/5 px-4 py-2.5",
                        "text-sm font-semibold text-[#d8b05a]",
                        "hover:bg-[#d8b05a]/10 transition",
                        "focus:outline-none focus:ring-4 focus:ring-[#d8b05a]/15",
                        "self-start",
                        ].join(" ")}
                    >
                        <Icon name="plus" className="h-4 w-4" />
                        Add Passenger
                    </button> */}
                </div>
                {/* Passenger cards */}
                <div className="mt-6 space-y-6">
                {passengers.map((p, idx) => (
                    <div
                    key={idx}
                    className="relative overflow-hidden rounded-2xl border border-white/10 bg-white/5"
                    >
                    <div className="relative">
                        {/* Card header */}
                        <div className="flex items-center justify-between border-b border-white/10 px-5 py-4">
                        <div className="text-[11px] font-semibold tracking-[0.28em] text-[#d8b05a]/80">
                            PRIMARY PASSENGER
                        </div>

                        {passengers.length > 1 && (
                            <button
                            type="button"
                            onClick={() => removePassenger(idx)}
                            className="rounded-lg p-2 text-white/40 hover:text-white/70"
                            aria-label="Remove passenger"
                            >
                            <Icon name="trash" />
                            </button>
                        )}
                        </div>

                        {/* Form */}
                        <div className="px-5 py-5">
                        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
                            <TextInput
                            label="First Name"
                            placeholder="e.g. Alexander"
                            value={p.firstName}
                            onChange={(v) => updatePassenger(idx, { firstName: v })}
                            />
                            <TextInput
                            label="Last Name"
                            placeholder="e.g. Rothschild"
                            value={p.lastName}
                            onChange={(v) => updatePassenger(idx, { lastName: v })}
                            />
                            <DateInput
                            label="Date of Birth"
                            value={p.dob}
                            onChange={(v) => updatePassenger(idx, { dob: v })}
                            />
                            <TextInput
                            label="Passport Number"
                            placeholder="A12345678"
                            value={p.passport}
                            onChange={(v) => updatePassenger(idx, { passport: v })}
                            />
                        </div>

                        {/* Fare section */}
                        <div className="mt-7">
                            <div className="text-base font-semibold text-white/90">
                            Select Experience Fare
                            </div>

                            <div className="mt-4 grid grid-cols-1 gap-4 lg:grid-cols-2">
                            {state?.flight_fares?.map((f) => (
                                <FareCard
                                key={f.id}
                                title={f.fare_name}
                                subtitle={f.fare_name}
                                price={f.price}
                                tag={f.tag}
                                selected={p.fareId === f.id}
                                onClick={() => updatePassenger(idx, { fareId: f.id })}
                                features={f.features}
                                />
                            ))}
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                ))}
                </div>
                <div className="mt-8 rounded-2xl border border-[#d8b05a]/25 bg-white/5 p-5 sm:p-6">
                    <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
                        <div>
                        <div className="text-[11px] tracking-[0.28em] text-white/40">
                            TOTAL ESTIMATED FARE
                        </div>
                        <div className="mt-2 flex items-end gap-3">
                            <div className="text-4xl font-semibold text-white/90">
                            {formattedTotal}
                            </div>
                            <div className="pb-1 text-sm text-white/50">USD</div>
                        </div>
                        </div>

                        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-end">
                        <button
                            type="button"
                            onClick={() => proceedToPay()}
                            className={[
                            "h-12 rounded-xl px-6 text-sm font-semibold",
                            "bg-[#d8b05a] text-black",
                            "hover:brightness-110 active:brightness-95 transition",
                            "focus:outline-none focus:ring-4 focus:ring-[#d8b05a]/20",
                            "inline-flex items-center justify-center gap-3",
                            ].join(" ")}
                        >
                            Proceed to Payment
                            <Icon name="arrow" className="h-5 w-5" />
                        </button>
                        </div>
                    </div>
                </div>
                
                <p className="mx-auto mt-4 text-center text-xs text-white/30">
                By proceeding, you agree to Roscroft&apos;s Private Charter Terms of Carriage and
                Privacy Policy. All prices include fuel surcharges and applicable landing fees.
                </p>
            </div>
        </div>
    )
}